import React, { Component } from 'react';
import firebase from 'firebase';

import RestrictedInput from './restricted-input/RestrictedInput.js';
import firebaseConfig from './firebaseConfig.js';

import './App.css';

class App extends Component {

  state = {
    isEditable: true,
    writingId: null,
    paragraphs: []
  }

  constructor(props) {
    super(props);
    firebase.initializeApp(firebaseConfig);
    this.database = firebase.database();
  }

  componentWillMount() {
    this.tryRestoreFromUrl();
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="tw-main-column">
            <h1>Typewrite</h1>
            { !this.isNewWriting() && <a className="tw-new-writing-button" onClick={this.newBlankWriting}>+</a> }
          </div>
        </header>
        <div className="App-main">
          <div className="Content tw-main-column">
            <RestrictedInput 
              placeholderText="Think it's paper, not screen"
              paragraphs={this.state.paragraphs}
              onTextChange={this.handleTextChange}
            />
          </div>
        </div>
      </div>
    );
  }

  isNewWriting() {
    return this.state.writingId === null;
  }

  isEditable() {
    return this.state.isEditable === true;
  }

  tryRestoreFromUrl() {
    // TODO use routing properly
    const writingId = window.location.pathname.replace('/', '');
    const isEditable = window.localStorage.getItem(`typewrite.authoredWritings.${writingId}`) !== null;
    // TODO make better validation
    if (writingId.length === 20) {
      this.database.ref('writings/' + writingId).on('value', this.handleValueUpdate);
      this.setState({
        writingId,
        isEditable
     });
    }
  }

  createWriting() {
    const writingId = this.database.ref().child('writings').push().key;
    window.localStorage.setItem(`typewrite.authoredWritings.${writingId}`, true);
    this.setState({
      writingId,
      paragraphs: []
    });
    window.history.replaceState({}, "", writingId);
    return writingId;
  }

  updateWriting(writingId, paragraphs) {
    const newState = { paragraphs };
    this.database.ref().child('writings/' + writingId).set(newState);
    this.setState(newState);
  }

  handleValueUpdate = (snapshot) => {
    this.setState({
      paragraphs: snapshot.val().paragraphs
    });
  }

  handleTextChange = ({ paragraphs }) => {
    if (this.isEditable()) {
      if (this.isNewWriting()) {
        this.createWriting();
      }
      this.updateWriting(this.state.writingId, paragraphs);
    }
  }

  newBlankWriting = () => {
    window.history.pushState({}, "", "/");
    this.setState({
      writingId: null,
      paragraphs: []
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js